import {
  IDashboardState,
  initIDashboardState,
} from '../states/aumye-dashboard.state';
import * as fromDashboardActions from '../actions/dashboard.action';
import { ConstantSetterAndGetterService } from 'src/app/app.constants';
import { Visitor } from 'src/app/models/visitor';
import { getAllAssetsFromPropertyArray } from 'src/app/utils/table-utils';
import { UserRegDetails } from 'src/app/models/user';
import {
  getbreakdownGraphData,
  getPieGraphData,
} from 'src/app/services/simulation/aumyeSim.utils';
import { IIncidents } from 'src/app/models/incident';
import { ComplaintsTickets } from 'src/app/models/tickets';

export function reducer(
  state = initIDashboardState,
  action: fromDashboardActions.CyclopsDashboardActionUnion
): IDashboardState {
  switch (action.type) {
    case fromDashboardActions.DashboardActionTypes.INIT_DASHBOARD: {
      const constants = new ConstantSetterAndGetterService().getConstants();
      return {
        ...state,
        flows: {
          ...state.flows,
          isDashboard: true,
          isReports: false,
          isVisitorGateEntry: false,
          isIncidentManualEvent: false,
          isShowWaitingSection: false,
          isUserProfile: false,
          isPreverifiedFlow: false,
          isAumyeCommunityFlow: false,
        },
        isAdmin: constants.USER_IS_ADMIN,
        organizationDetails: {
          ...state.organizationDetails,
          orgId: constants.ORGANIZATION_ID,
        },
        orgUsers: {
          ...state.orgUsers,
          userId: constants.USER_ID,
          userDetail: {
            ...state.orgUsers.userDetail,
            email: constants.USER_EMAIL,
            firstName: constants.USER_FIRST_NAME,
            lastName: constants.USER_LAST_NAME,
            gender: constants.USER_GENDER,
            dob: constants.USER_DOB,
            mobileNumber: constants.USER_MOBILE_NUMBER,
            role: constants.USER_ROLE,
            profilePictureUrl: constants.USER_PROFILE_PICTURE,
          },
        },
        Constants: constants,
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_CALENDAR_TAB: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isDashboard: false,
          isCalendar: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_REPORTS_TAB: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isDashboard: false,
          isReports: true,
          isVisitorGateEntry: false,
          isIncidentManualEvent: false,
          isPreverifiedFlow: false,
          isAumyeCommunityFlow: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_ASSETS_TAB: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isDashboard: false,
          isAssets: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_USER_PROFILE_SETTING: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isUserProfile: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_PRE_VERIFIED_TAB: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isPreverifiedFlow: true,
          isAumyeCommunityFlow: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_AUMYE_COMMUNITY: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isAumyeCommunityFlow: true,
          isPreverifiedFlow: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .INIT_VISITOR_GATE_ENTRY_TAB: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isVisitorGateEntry: true,
          isShowWaitingSection: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .INIT_INCIDENT_MANUAL_EVENT_TAB: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isIncidentManualEvent: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_DASHBOARD_DATA: {
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_DASHBOARD_DATA_SUCCESS: {
      const {
        payload: {
          incidentData: {
            totalUnassigned,
            totalSnoozed,
            totalClosed,
            todaysClosed,
            totalOpen,
            todaysOpen,
            incidentList,
            criticalIncidentList,
            mediumIncidentList,
            lowIncidentList,
            noIncidentList,
            recentActivityIncidentList,
            totalIncident,
            todaysIncident,
            breakdownGraphData,
            incidentGraphCounts,
            totalFire,
            totalIntrusion,
            totalFaceMatch,
            totalAnpr,
          },
          orgUsersData,
          visitorData: {
            totalUnverified,
            totalVerified,
            totalVisitor,
            singleTotal,
            totalSingleVerified,
            totalSingleUnverified,
            totalPending,
            totalAutoRejected,
            totalRejected,
            visitorList,
            visitorBreakdownGraphData,
          },
          orgSettingData,
          userId,
        },
      } = action;
      let orgUsers: UserRegDetails[] = orgUsersData;
      const loggedInUser = orgUsers.filter((x) => x.userId === userId)[0];
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isDashboardDataLoaded: true,
          isOrgUserDetailsLoaded: true,
        },
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: incidentList ? incidentList : [],
          criticalIncidentList: criticalIncidentList
            ? criticalIncidentList
            : [],
          mediumIncidentList: mediumIncidentList ? mediumIncidentList : [],
          lowIncidentList: lowIncidentList ? lowIncidentList : [],
          noIncidentList: noIncidentList ? noIncidentList : [],
          recentActivityIncidentList: recentActivityIncidentList
            ? recentActivityIncidentList
            : [],
          totalIncidents: totalIncident,
          totalOpen: totalOpen,
          totalClosed: totalClosed,
          totalSnoozed: totalSnoozed,
          totalUnassigned: totalUnassigned,
          breakdownGraphData: breakdownGraphData,
          incidentGraphCounts: incidentGraphCounts,
          totalFire: totalFire,
          totalIntrusion: totalIntrusion,
          totalFaceMatch: totalFaceMatch,
          totalAnpr: totalAnpr,
          todaysClosed: todaysClosed,
          todaysOpen: todaysOpen,
          todaysIncident: todaysIncident,
        },
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: visitorList ? visitorList : [],
          totalUnverified: totalUnverified,
          singleTotal,
          totalSingleVerified,
          totalSingleUnverified,
          totalVisitor: totalVisitor,
          totalVerified: totalVerified,
          totalPending: totalPending,
          totalAutoRejected: totalAutoRejected,
          totalRejected: totalRejected,
          breakdownGraphData: visitorBreakdownGraphData,
        },
        orgUserList: orgUsersData,
        loggedInUserDetails: loggedInUser,
        OrganizationSettings: orgSettingData,
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_VISITOR_TAB_DATA: {
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: true,
          isLodingVisitorDashboardData: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_VISITOR_TAB_DATA_FAILURE: {
      const { payload } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isLodingVisitorDashboardData: false,
          isVisitorDataLoaded: false,
          isError: true,
        },
        Error: {
          ...state.Error,
          errorMessage: payload.global,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_RANGED_INCIDENT_DATA_SUCCESS: {
      let parsedPaylaod = JSON.parse(action.payload);
      let {
        totalUnassigned,
        totalSnoozed,
        totalClosed,
        todaysClosed,
        totalOpen,
        todaysOpen,
        incidentList,
        criticalIncidentList,
        mediumIncidentList,
        lowIncidentList,
        noIncidentList,
        totalIncident,
        todaysIncident,
        breakdownGraphData,
        incidentGraphCounts,
        totalFire,
        totalIntrusion,
        totalFaceMatch,
        totalAnpr,
      } = parsedPaylaod;
      return {
        ...state,
        status: {
          ...state.status,
        },
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: incidentList ? incidentList : [],
          criticalIncidentList: criticalIncidentList
            ? criticalIncidentList
            : [],
          mediumIncidentList: mediumIncidentList ? mediumIncidentList : [],
          lowIncidentList: lowIncidentList ? lowIncidentList : [],
          noIncidentList: noIncidentList ? noIncidentList : [],
          totalIncidents: totalIncident,
          totalOpen: totalOpen,
          totalClosed: totalClosed,
          totalSnoozed: totalSnoozed,
          totalUnassigned: totalUnassigned,
          breakdownGraphData: breakdownGraphData,
          incidentGraphCounts: incidentGraphCounts,
          totalFire: totalFire,
          totalIntrusion: totalIntrusion,
          totalFaceMatch: totalFaceMatch,
          totalAnpr: totalAnpr,
          todaysClosed: todaysClosed,
          todaysOpen: todaysOpen,
          todaysIncident: todaysIncident,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_INCIDENT_TAB_DATA_SUCCESS: {
      let {
        payload: {
          totalUnassigned,
          totalSnoozed,
          totalClosed,
          todaysClosed,
          totalOpen,
          todaysOpen,
          incidentList,
          criticalIncidentList,
          mediumIncidentList,
          lowIncidentList,
          noIncidentList,
          totalIncident,
          todaysIncident,
          breakdownGraphData,
          incidentGraphCounts,
          totalFire,
          totalIntrusion,
          totalFaceMatch,
          totalAnpr,
        },
      } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isIncidentDataLoaded: true,
        },
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: incidentList ? incidentList : [],
          criticalIncidentList: criticalIncidentList
            ? criticalIncidentList
            : [],
          mediumIncidentList: mediumIncidentList ? mediumIncidentList : [],
          lowIncidentList: lowIncidentList ? lowIncidentList : [],
          noIncidentList: noIncidentList ? noIncidentList : [],
          totalIncidents: totalIncident,
          totalOpen: totalOpen,
          totalClosed: totalClosed,
          totalSnoozed: totalSnoozed,
          totalUnassigned: totalUnassigned,
          breakdownGraphData: breakdownGraphData,
          incidentGraphCounts: incidentGraphCounts,
          totalFire: totalFire,
          totalIntrusion: totalIntrusion,
          totalFaceMatch: totalFaceMatch,
          totalAnpr: totalAnpr,
          todaysClosed: todaysClosed,
          todaysOpen: todaysOpen,
          todaysIncident: todaysIncident,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_RANGED_VISITOR_DATA_SUCCESS: {
      let parsedPaylaod = JSON.parse(action.payload);
      let {
        totalUnverified,
        totalVerified,
        totalVisitor,
        visitorList,
        totalPending,
        totalAutoRejected,
        totalRejected,
        visitorBreakdownGraphData,
      } = parsedPaylaod;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isLodingVisitorDashboardData: false,
          isVisitorDataLoaded: true,
        },
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: visitorList ? visitorList : [],
          totalUnverified: totalUnverified,
          totalVisitor: totalVisitor,
          totalVerified: totalVerified,
          totalPending: totalPending,
          totalAutoRejected: totalAutoRejected,
          totalRejected: totalRejected,
          breakdownGraphData: visitorBreakdownGraphData,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_VISITOR_TAB_DATA_SUCCESS: {
      let {
        payload: {
          totalUnverified,
          totalVerified,
          totalVisitor,
          visitorList,
          totalPending,
          totalAutoRejected,
          totalRejected,
          visitorBreakdownGraphData,
        },
      } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isLodingVisitorDashboardData: false,
          isVisitorDataLoaded: true,
        },
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: visitorList ? visitorList : [],
          totalUnverified: totalUnverified,
          totalVisitor: totalVisitor,
          totalVerified: totalVerified,
          totalPending: totalPending,
          totalAutoRejected: totalAutoRejected,
          totalRejected: totalRejected,
          breakdownGraphData: visitorBreakdownGraphData,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_VISITOR_LIST_SUCCESS: {
      let {
        payload: {
          totalUnverified,
          totalVerified,
          totalVisitor,
          visitorList,
          visitorBreakdownGraphData,
        },
      } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isLodingVisitorDashboardData: false,
          isVisitorDataLoaded: true,
        },
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: visitorList ? visitorList : [],
          totalUnverified: totalUnverified,
          totalVisitor: totalVisitor,
          totalVerified: totalVerified,
          breakdownGraphData: visitorBreakdownGraphData,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_INCIDENT_LIST_SUCCESS: {
      let {
        payload: {
          totalUnassigned,
          totalSnoozed,
          totalClosed,
          todaysClosed,
          totalOpen,
          todaysOpen,
          incidentList,
          criticalIncidentList,
          mediumIncidentList,
          recentActivityIncidentList,
          lowIncidentList,
          noIncidentList,
          totalIncident,
          todaysIncident,
          breakdownGraphData,
          incidentGraphCounts,
          totalFire,
          totalIntrusion,
          totalFaceMatch,
          totalAnpr,
        },
      } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isIncidentDataLoaded: true,
        },
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: incidentList ? incidentList : [],
          criticalIncidentList: criticalIncidentList
            ? criticalIncidentList
            : [],
          mediumIncidentList: mediumIncidentList ? mediumIncidentList : [],
          lowIncidentList: lowIncidentList ? lowIncidentList : [],
          noIncidentList: noIncidentList ? noIncidentList : [],
          recentActivityIncidentList: recentActivityIncidentList
            ? recentActivityIncidentList
            : [],
          totalIncidents: totalIncident,
          totalOpen: totalOpen,
          totalClosed: totalClosed,
          totalSnoozed: totalSnoozed,
          totalUnassigned: totalUnassigned,
          breakdownGraphData: breakdownGraphData,
          incidentGraphCounts: incidentGraphCounts,
          totalFire: totalFire,
          totalIntrusion: totalIntrusion,
          totalFaceMatch: totalFaceMatch,
          totalAnpr: totalAnpr,
          todaysClosed: todaysClosed,
          todaysOpen: todaysOpen,
          todaysIncident: todaysIncident,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.USER_LOGOUT: {
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.RESET_STATE: {
      return initIDashboardState;
    }
    case fromDashboardActions.DashboardActionTypes.GET_USER_LIST_SUCCESS: {
      let { payload } = action;
      let orgUsers: UserRegDetails[] = payload;
      let userId = payload.UserId;
      const loggedInUser = orgUsers.filter((x) => x.userId === userId)[0];
      return {
        ...state,
        orgUserList: payload,
        loggedInUserDetails: loggedInUser,
        status: {
          ...state.status,
          isOrgUserDetailsLoaded: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SAVE_APP_TOKEN_SUCCESS: {
      return {
        ...state,
        status: {
          ...state.status,
          isPushNotificationTokenRegistered: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SAVE_APP_TOKEN_FAILURE: {
      return {
        ...state,
        status: {
          ...state.status,
          isPushNotificationTokenRegistered: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.LOAD_ALL_ASSETS_SUCCESS: {
      let { payload } = action;
      let assets = getAllAssetsFromPropertyArray(payload);
      return {
        ...state,
        orgAssetList: {
          property: payload,
          assets: assets,
        },
        status: {
          ...state.status,
          isAssetsLoaded: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.VISITOR_NOTIFY_HOST: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isShowWaitingSection: false,
        },
        status: {
          ...state.status,
          isFetchingAPIRequest: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .VISITOR_NOTIFY_HOST_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
        },
        gateEntryVisitor: {
          ...state.gateEntryVisitor,
          isHostNotified: true,
          visitorId: payload,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .VISITOR_NOTIFY_HOST_FAILURE: {
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
        },
        gateEntryVisitor: {
          ...state.gateEntryVisitor,
          isHostNotified: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.HOST_STATUS: {
      return {
        ...state,
        gateEntryVisitor: {
          ...state.gateEntryVisitor,
          isFetchingHostStatus: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.HOST_STATUS_SUCCESS: {
      let { payload } = action;
      const vidDet: Visitor = JSON.parse(payload);
      let {
        visitorDetails: { visitorList },
      } = state;
      const tempVisList = JSON.parse(JSON.stringify(visitorList));
      tempVisList.forEach((item: Visitor) => {
        if (item.visitorID == vidDet.visitorID) {
          item.isHostVerified = vidDet.isHostVerified;
          item.securityStatus = vidDet.securityStatus;
        }
      });

      return {
        ...state,
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: tempVisList,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .CREATE_MANUAL_INCIDENT_SUCCESS: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isIncidentManualEvent: false,
        },
        manualIncidentEvent: {
          ...state.manualIncidentEvent,
          isNotified: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_NUMBER_PLATES_LIST_SUCCESS: {
      let { payload } = action;
      // let number :NumberPlates;
      // let sortedList = payload.sort(function(x: any, y: any){
      //   return newx.plateAddDate.timestamp - y.plateAddDate.timestamp;
      // })
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
          isNumberPlatesLoaded: true,
        },
        orgVehicleNumberPlates: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_FACE_TIMELINE_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isFetchingAPIRequest: false,
        },
        facaTimeline: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_INCIDENT_EVIDENCE: {
      return {
        ...state,
        status: {
          ...state.status,
          isGettingEvidence: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_INCIDENT_EVIDENCE_FAILURE: {
      return {
        ...state,
        status: {
          ...state.status,
          isGettingEvidence: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_NOTICE_BOARD_POSTS_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        noticeBoardPosts: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_USER_EVENTS_LIST_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        userEvents: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_USER_POLL_LIST_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        userPolls: payload,
      };
    }
    // case fromDashboardActions.DashboardActionTypes.ADD_NEW_INCIDENT_SUCCESS: {
    //   let { payload } = action;
    //   const updatedIncidentList = [
    //     payload,
    //     ...state.incidentDetails.incidentList,
    //   ];

    //   return {
    //     ...state,
    //     incidentDetails: {
    //       ...state.incidentDetails,
    //       incidentList: updatedIncidentList,
    //     },
    //   };
    // }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_VISITOR_ID_DETAIL_SUCCESS: {
      let { payload } = action;
      const updatedVisitor: Visitor = payload;
      // const updatedVisitorIndex = state.visitorDetails.visitorList.findIndex(
      //   (visitor) => visitor.visitorID === visitor.visitorID
      // );
      const updatedVisitorList = state.visitorDetails.visitorList.map(
        (visitor) => {
          if (visitor.visitorID === updatedVisitor.visitorID)
            if (visitor.visitorID === updatedVisitor.visitorID) {
              // Update the specific visitor
              return updatedVisitor;
            }
          return visitor;
        }
      );
      return {
        ...state,
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: updatedVisitorList,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.UPDATE_ASSETS_DATA: {
      let { payload } = action;
      let assets = getAllAssetsFromPropertyArray(payload);
      return {
        ...state,
        orgAssetList: {
          property: payload,
          assets: assets,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.FETCH_EMPLOYEES_SUCCESS: {
      let { payload } = action;

      return {
        ...state,
        Employees: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.SEARCH_NUMBER: {
      return {
        ...state,
        status: {
          ...state.status,
          isError: false,
          isNumberFound: false,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SEARCH_NUMBER_FAILURE: {
      return {
        ...state,
        status: {
          ...state.status,
          isError: true,
          isNumberFound: false,
        },
        Error: {
          errorMessage: 'Number Not Found',
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SEARCH_NUMBER_SUCCESS: {
      let { payload } = action;
      payload = JSON.parse(payload);
      return {
        ...state,
        status: {
          ...state.status,
          isError: false,
          isNumberFound: true,
        },
        Searchednumber: {
          numberPlate: payload.number,
          incidentId: payload.incidentId,
          matchScore: payload.score,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_ORG_SETTINGS_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        OrganizationSettings: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_USER_INVENTORY_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        userInventory: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_COMPLAINTS_TICKET_SUCCESS: {
      let { payload } = action;

      return {
        ...state,
        complaintsTickets: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.GET_CLAIM_TICKET_SUCCESS: {
      let { payload } = action;

      return {
        ...state,
        claimTickets: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_REQUESTS_TICKET_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        requestsTickets: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .GET_RANGED_REQUEST_DATA_SUCCESS: {
      let { payload } = action;
      let type = payload.payload.type;
      let parsedPayload = JSON.parse(payload.res);
      payload;
      return {
        ...state,
        requestsTickets:
          type == 'REQUESTS' ? parsedPayload : state.requestsTickets,
        complaintsTickets:
          type == 'COMPLAIN' ? parsedPayload : state.complaintsTickets,
        claimTickets: type == 'CLAIM' ? parsedPayload : state.claimTickets,
      };
    }
    case fromDashboardActions.DashboardActionTypes.SAVE_SOS_DATA: {
      let { payload } = action;
      return {
        ...state,
        orgSOSData: {
          ...state.orgSOSData,
          requests: [payload, ...state.orgSOSData.requests],
          requestsDetails: [payload, ...state.orgSOSData.requestsDetails],
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.INIT_SIMULATION: {
      return {
        ...state,
        status: {
          ...state.status,
          isSimulationStarted: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SAVE_PROPERTY_DATA: {
      let { payload } = action;
      let assets = getAllAssetsFromPropertyArray(payload);
      return {
        ...state,
        orgAssetList: {
          property: payload,
          assets: assets,
        },
        status: {
          ...state.status,
          isAssetsLoaded: true,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SAVE_USER_DATA: {
      let { payload } = action;
      return {
        ...state,
        orgUserList: payload,
      };
    }

    case fromDashboardActions.DashboardActionTypes.SAVE_INCIDENT_DATA: {
      let { payload } = action;
      let { incidentDetails } = state;
      let updatedList = [payload, ...incidentDetails.incidentList];
      return {
        ...state,
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: updatedList,
          totalIncidents: updatedList.length,
          totalOpen: updatedList.filter((x) => x.incidentStatus == 0).length,
          totalClosed: updatedList.filter((x) => x.incidentStatus == 1).length,
          // breakdownGraphData: breakdownGraphData,
          totalFire:
            updatedList.filter((x) => x.incidentName == 'Fire Verified')
              .length +
            updatedList.filter((x) => x.incidentName == 'Fire Unverified')
              .length,
          totalIntrusion: updatedList.filter(
            (x) => x.incidentName == 'Intrusion'
          ).length,
          totalFaceMatch: updatedList.filter((x) => x.incidentName == 'Face')
            .length,
          totalAnpr: updatedList.filter((x) => x.incidentName == 'ANPR').length,
          manualCount: updatedList.filter((x) => x.incidentType == 'Manual')
            .length,
          securityCallbacksCount: updatedList.filter(
            (x) => x.incidentName == 'Security Callback'
          ).length,
          serviceRequestCount: updatedList.filter(
            (x) => x.incidentName == 'Service Request'
          ).length,
          soSAlertsCount: updatedList.filter(
            (x) => x.incidentName == 'Advanced SOS'
          ).length,
          systemFailureCount: updatedList.filter(
            (x) => x.incidentName == 'APIFailure'
          ).length,
          deviceFailureCount: updatedList.filter(
            (x) => x.incidentName == 'DeviceFailure'
          ).length,
          claimsCount: updatedList.filter((x) => x.incidentName == 'Claim')
            .length,
          todaysClosed: incidentDetails.totalClosed,
          todaysOpen: incidentDetails.totalOpen,
          todaysIncident: incidentDetails.totalIncidents,
          breakdownGraphData: getbreakdownGraphData(updatedList),
          incidentGraphCounts: getPieGraphData(updatedList),
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.UPDATE_INCIDENT_DATA: {
      let { payload } = action;
      let { incidentDetails } = state;
      let updatedList: IIncidents[] = payload;
      let incidentsData = getSectionIncidents(updatedList);
      let criticalIncidentList: IIncidents[] =
        incidentsData.criticalIncidentList;
      let mediumIncidentList: IIncidents[] = incidentsData.mediumIncidentList;
      let lowIncidentList: IIncidents[] = incidentsData.lowNoIncidentList;
      return {
        ...state,
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: updatedList,
          criticalIncidentList: criticalIncidentList,
          mediumIncidentList: mediumIncidentList,
          totalIncidents: updatedList.length,
          lowIncidentList: lowIncidentList,
          totalOpen: updatedList.filter((x) => x.incidentStatus == 0).length,
          totalClosed: updatedList.filter((x) => x.incidentStatus == 1).length,
          // breakdownGraphData: breakdownGraphData,
          // totalFire: updatedList.filter((x) => x.incidentName == 'Fire').length, updatedList.filter((x) => x.incidentName == 'Fire Verified').length
          totalFire:
            updatedList.filter((x) => x.incidentName == 'Fire Verified')
              .length +
            updatedList.filter((x) => x.incidentName == 'Fire Unverified')
              .length,
          totalIntrusion: updatedList.filter(
            (x) => x.incidentName == 'Intrusion'
          ).length,
          totalFaceMatch: updatedList.filter((x) => x.incidentName == 'Face')
            .length,
          totalAnpr: updatedList.filter((x) => x.incidentName == 'ANPR').length,
          manualCount: updatedList.filter((x) => x.incidentType == 'Manual')
            .length,
          securityCallbacksCount: updatedList.filter(
            (x) => x.incidentName == 'Security Callback'
          ).length,
          serviceRequestCount: updatedList.filter(
            (x) => x.incidentName == 'Service Request'
          ).length,
          soSAlertsCount: updatedList.filter(
            (x) => x.incidentName == 'Advanced SOS'
          ).length,
          systemFailureCount: updatedList.filter(
            (x) => x.incidentName == 'APIFailure'
          ).length,
          deviceFailureCount: updatedList.filter(
            (x) => x.incidentName == 'DeviceFailure'
          ).length,
          claimsCount: updatedList.filter((x) => x.incidentName == 'Claim')
            .length,
          todaysClosed: incidentDetails.totalClosed,
          todaysOpen: incidentDetails.totalOpen,
          todaysIncident: incidentDetails.totalIncidents,
          breakdownGraphData: getbreakdownGraphData(updatedList),
          incidentGraphCounts: getPieGraphData(updatedList),
        },
      };
    }

    case fromDashboardActions.DashboardActionTypes.SAVE_RISK_DATA: {
      let {
        payload: {
          riskAnalyticsGraph,
          riskData,
          riskSingleAnalyticsGraph,
          criticalIncidentsCounts,
          criticalIncidentsData,
          criticalIncidentsCountNumber,
          averageCloseTime,
          currentMonthRiskScore,
          previousMonthRiskScore,
          criticalRiskHour,
          heatMapData,
          riskAnalyticsStatusGraph,
          totalClaimAmountCurrent,
          totalClaimAmountPrevious,
          previousMonthClaimData,
          currentMonthClaimData,
          riskAnalyticsPreviousMonthGraph,
        },
      } = action;
      return {
        ...state,
        orgRiskData: {
          ...state.orgRiskData,
          riskQuestions: riskData,
          riskAnalyticsGraph: riskAnalyticsGraph,
          riskAnalyticsPreviousMonthGraph: riskAnalyticsPreviousMonthGraph,
          riskSingleAnalyticsGraph: riskSingleAnalyticsGraph,
          averageCloseTime: averageCloseTime,
          criticalIncidentsCounts: criticalIncidentsCounts,
          criticalIncidentsData: criticalIncidentsData,
          criticalIncidentsCountNumber: criticalIncidentsCountNumber,
          currentMonthRiskScore: currentMonthRiskScore,
          previousMonthRiskScore: previousMonthRiskScore,
          criticalRiskHour: criticalRiskHour,
          riskHeatMapData: heatMapData,
          riskAnalyticsStatusGraph: riskAnalyticsStatusGraph,
          currentMonthClaimTotal: currentMonthClaimData,
          previousMonthClaimTotal: previousMonthClaimData,
          currentMonthClaimAmount: totalClaimAmountCurrent,
          previousMonthClaimAmount: totalClaimAmountPrevious,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.SAVE_COMPLAIN_DATA: {
      let { payload } = action;
      let { complaintsTickets } = state;
      let updatedList: ComplaintsTickets[] = [...payload, ...complaintsTickets];
      return {
        ...state,
        complaintsTickets: updatedList,
      };
    }
    case fromDashboardActions.DashboardActionTypes.UPDATE_COMPLAIN_DATA: {
      let { payload } = action;
      // let updatedList: ComplaintsTickets[] = [...payload, ...complaintsTickets];
      return {
        ...state,
        complaintsTickets: payload,
      };
    }
    case fromDashboardActions.DashboardActionTypes.UPDATE_SOS_DATA: {
      let { payload } = action;
      // let updatedList: ComplaintsTickets[] = [...payload, ...complaintsTickets];
      return {
        ...state,
        orgSOSData: {
          ...state.orgSOSData,
          requests: payload,
          requestsDetails: payload,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_INCIDENT_BY_ID_SUCCESS: {
      let { payload } = action;
      const updateIncidentInList = (list: IIncidents[]) =>
        list.map((incident) =>
          incident.incidentId === payload.res.incidentId
            ? { ...incident, ...payload.res }
            : incident
        );
      const updatedIncidentList: IIncidents[] = updateIncidentInList(
        state.incidentDetails.incidentList
      );
      const incidentGraphCounts = updatedIncidentList.reduce(
        (acc, incident) => {
          switch (incident.incidentStatus) {
            case 0:
              acc.openCount++;
              break;
            case 1:
              acc.closedCount++;
              break;
            case 2:
              acc.verifiedCount++;
              break;
            case 3:
              acc.snoozedCount++;
              break;
            case 4:
              acc.inProgressCount++;
              break;
            case 5:
              acc.onHoldCount++;
              break;
            case 6:
              acc.approvedCount++;
              break;
            case 7:
              acc.rejectedCount++;
              break;
            case 8:
              acc.completeCount++;
              break;
          }
          return acc;
        },
        {
          openCount: 0,
          closedCount: 0,
          inProgressCount: 0,
          onHoldCount: 0,
          completeCount: 0,
          approvedCount: 0,
          rejectedCount: 0,
          verifiedCount: 0,
          snoozedCount: 0,
        }
      );
      return {
        ...state,
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: updateIncidentInList(
            state.incidentDetails.incidentList
          ),
          criticalIncidentList: updateIncidentInList(
            state.incidentDetails.criticalIncidentList
          ),
          mediumIncidentList: updateIncidentInList(
            state.incidentDetails.mediumIncidentList
          ),
          lowIncidentList: updateIncidentInList(
            state.incidentDetails.lowIncidentList
          ),
          noIncidentList: updateIncidentInList(
            state.incidentDetails.noIncidentList
          ),
          recentActivityIncidentList: updateIncidentInList(
            state.incidentDetails.recentActivityIncidentList
          ),
          incidentGraphCounts: {
            ...state.incidentDetails.incidentGraphCounts,
            openCount: incidentGraphCounts.openCount,
            closedCount: incidentGraphCounts.closedCount,
            inProgressCount: incidentGraphCounts.inProgressCount,
            onHoldCount: incidentGraphCounts.onHoldCount,
            completeCount: incidentGraphCounts.completeCount,
            approvedCount: incidentGraphCounts.approvedCount,
            rejectedCount: incidentGraphCounts.rejectedCount,
            verifiedCount: incidentGraphCounts.verifiedCount,
            snoozedCount: incidentGraphCounts.snoozedCount,
          },
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.REMOVE_INCIDENT_BY_ID: {
      const { payload } = action;
      const incidentIdToRemove = payload.Id;

      const removeIncidentFromList = (list: IIncidents[]) =>
        list.filter((incident) => incident.incidentId !== incidentIdToRemove);
      return {
        ...state,
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: removeIncidentFromList(
            state.incidentDetails.incidentList
          ),
          criticalIncidentList: removeIncidentFromList(
            state.incidentDetails.criticalIncidentList
          ),
          mediumIncidentList: removeIncidentFromList(
            state.incidentDetails.mediumIncidentList
          ),
          lowIncidentList: removeIncidentFromList(
            state.incidentDetails.lowIncidentList
          ),
          noIncidentList: removeIncidentFromList(
            state.incidentDetails.noIncidentList
          ),
          recentActivityIncidentList: removeIncidentFromList(
            state.incidentDetails.recentActivityIncidentList
          ),
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_INCIDENT_SUCCESS: {
      let { payload } = action;
      const updateIncidentInList = (list: IIncidents[]): IIncidents[] => {
        return [payload.res, ...list];
      };
      return {
        ...state,
        incidentDetails: {
          ...state.incidentDetails,
          incidentList: updateIncidentInList(
            state.incidentDetails.incidentList
          ),
          criticalIncidentList:
            payload.res.riskCategory === 'Critical'
              ? updateIncidentInList(state.incidentDetails.criticalIncidentList)
              : state.incidentDetails.criticalIncidentList,
          mediumIncidentList:
            payload.res.riskCategory === 'Medium'
              ? updateIncidentInList(state.incidentDetails.mediumIncidentList)
              : state.incidentDetails.mediumIncidentList,
          lowIncidentList:
            payload.res.riskCategory === 'Low'
              ? updateIncidentInList(state.incidentDetails.lowIncidentList)
              : state.incidentDetails.lowIncidentList,
          noIncidentList:
            payload.res.riskCategory === 'No'
              ? updateIncidentInList(state.incidentDetails.noIncidentList)
              : state.incidentDetails.noIncidentList,
          recentActivityIncidentList:
            payload.res.riskCategory === 'recentActivity'
              ? updateIncidentInList(
                  state.incidentDetails.recentActivityIncidentList
                )
              : state.incidentDetails.recentActivityIncidentList,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.REMOVE_COMPLAINTS_BY_ID: {
      const { payload } = action; // payload should contain the id to remove
      const removeComplaintFromList = (
        list: ComplaintsTickets[]
      ): ComplaintsTickets[] => {
        return list.filter(
          (ticket) =>
            ticket.complainId.toLowerCase() !== payload.Id.toLowerCase()
        );
      };
      return {
        ...state,
        complaintsTickets: removeComplaintFromList(state.complaintsTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.REMOVE_CLAIMS_BY_ID: {
      const { payload } = action;
      const removeClaimFromList = (
        list: ComplaintsTickets[]
      ): ComplaintsTickets[] => {
        return list.filter(
          (ticket) =>
            ticket.complainId.toLowerCase() !== payload.Id.toLowerCase()
        );
      };
      return {
        ...state,
        claimTickets: removeClaimFromList(state.claimTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.REMOVE_SERVICE_BY_ID: {
      const { payload } = action;
      const removeRequestFromList = (
        list: ComplaintsTickets[]
      ): ComplaintsTickets[] => {
        return list.filter(
          (ticket) =>
            ticket.complainId.toLowerCase() !== payload.Id.toLowerCase()
        );
      };
      return {
        ...state,
        requestsTickets: removeRequestFromList(state.requestsTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_COMPLAINT_SUCCESS: {
      let { payload } = action;
      const updateComplaintInList = (
        list: ComplaintsTickets[]
      ): ComplaintsTickets[] => {
        return [payload.res, ...list];
      };
      return {
        ...state,
        complaintsTickets: updateComplaintInList(state.complaintsTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_CLAIM_SUCCESS: {
      let { payload } = action;
      const updateClaimInList = (
        list: ComplaintsTickets[]
      ): ComplaintsTickets[] => {
        return [payload.res, ...list];
      };
      return {
        ...state,
        claimTickets: updateClaimInList(state.claimTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_REQUEST_SUCCESS: {
      let { payload } = action;
      const updateRequestInList = (
        list: ComplaintsTickets[]
      ): ComplaintsTickets[] => {
        return [payload.res, ...list];
      };
      return {
        ...state,
        requestsTickets: updateRequestInList(state.requestsTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_REQUEST_BY_ID_SUCCESS: {
      let { payload } = action;
      const updateRequestInList = (list: ComplaintsTickets[]) =>
        list.map((complain) =>
          complain.complainId === payload.res.complainId
            ? { ...complain, ...payload.res }
            : complain
        );
      return {
        ...state,
        requestsTickets: updateRequestInList(state.requestsTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.UPDATE_CLAIM_BY_ID_SUCCESS: {
      let { payload } = action;
      const updateRequestInList = (list: ComplaintsTickets[]) =>
        list.map((complain) =>
          complain.complainId === payload.res.complainId
            ? { ...complain, ...payload.res }
            : complain
        );
      return {
        ...state,
        claimTickets: updateRequestInList(state.claimTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_COMPLAINT_BY_ID_SUCCESS: {
      let { payload } = action;
      const updateRequestInList = (list: ComplaintsTickets[]) =>
        list.map((complain) =>
          complain.complainId === payload.res.complainId
            ? { ...complain, ...payload.res }
            : complain
        );
      return {
        ...state,
        complaintsTickets: updateRequestInList(state.complaintsTickets),
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_USER_SUCCESS: {
      let { payload } = action;
      const updateOrgUsersInList = (
        list: UserRegDetails[]
      ): UserRegDetails[] => {
        return [payload.res, ...list];
      };
      return {
        ...state,
        orgUserList: updateOrgUsersInList(state.orgUserList),
      };
    }
    case fromDashboardActions.DashboardActionTypes
      .UPDATE_VISITOR_BY_ID_SUCCESS: {
      let { payload } = action;
      let {
        res: {
          totalUnverified,
          totalVerified,
          totalVisitor,
          singleTotal,
          totalSingleVerified,
          totalSingleUnverified,
          totalPending,
          totalAutoRejected,
          totalRejected,
          visitorList,
          visitorBreakdownGraphData,
        },
      } = payload;
      return {
        ...state,
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: visitorList ? visitorList : [],
          totalUnverified: totalUnverified,
          singleTotal,
          totalSingleVerified,
          totalSingleUnverified,
          totalVisitor: totalVisitor,
          totalVerified: totalVerified,
          totalPending: totalPending,
          totalAutoRejected: totalAutoRejected,
          totalRejected: totalRejected,
          breakdownGraphData: visitorBreakdownGraphData,
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_VISITOR_SUCCESS: {
      let { payload } = action;
      const updateVisitorInList = (list: Visitor[]): Visitor[] => {
        return [payload.res, ...list];
      };
      return {
        ...state,
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: updateVisitorInList(state.visitorDetails.visitorList),
        },
      };
    }
    case fromDashboardActions.DashboardActionTypes.ADD_NEW_NOTIFICATION: {
      let { payload } = action;
      return {
        ...state,
      };
    }
  }
  return state;
}

export function getSectionIncidents(incident: IIncidents[]) {
  let analyticsData: any[] = JSON.parse(localStorage.getItem('Risks'));
  let CriticalIncidents = analyticsData
    .filter((risk) => risk.riskCriticality == '100')
    .map((risk) => risk.riskQuestion);
  let MediumIncidents = analyticsData
    .filter((risk) => risk.riskCriticality == '50')
    .map((risk) => risk.riskQuestion);
  let LowNoIncidents = analyticsData
    .filter(
      (risk) => risk.riskCriticality == '0' || risk.riskCriticality == '25'
    )
    .map((risk) => risk.riskQuestion);
  let criticalIncidentList: any[] = [];
  let mediumIncidentList: any[] = [];
  let lowNoIncidentList: any[] = [];
  for (let i = 0; i < incident.length; i++) {
    if (
      CriticalIncidents.some(
        (ci) => ci.toLowerCase() === incident[i].incidentName.toLowerCase()
      )
    ) {
      criticalIncidentList.push(incident[i]);
    }
    // Check if the IncidentName matches any in MediumIncidents (case-insensitive)
    else if (
      MediumIncidents.some(
        (ci) => ci.toLowerCase() === incident[i].incidentName.toLowerCase()
      )
    ) {
      mediumIncidentList.push(incident[i]);
    }
    // Otherwise, add to lowNoIncidentList
    else {
      lowNoIncidentList.push(incident[i]);
    }
  }
  const data = {
    criticalIncidentList: criticalIncidentList,
    mediumIncidentList: mediumIncidentList,
    lowNoIncidentList: lowNoIncidentList,
  };
  return data;
}
function lowerCaseFirstLetterOfKeys(data: any): any {
  if (Array.isArray(data)) {
    return data.map((item) => lowerCaseFirstLetterOfKeys(item));
  } else if (typeof data === 'object' && data !== null) {
    return Object.keys(data).reduce((acc: any, key: string) => {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      acc[newKey] = data[key];
      return acc;
    }, {});
  }
  return data;
}
